import { Address } from '../util/address.model';

export abstract class UnitLeader {
  name: string;
  position: string;
  address: Address;
  addressPublic: boolean;
  workPhone: string;
  workPhonePublic: boolean;
  homePhone: string;
  homePhonePublic: boolean;
  cellPhone: string;
  cellPhonePublic: boolean;
  email: string;
  emailPublic: boolean;
  modifiedBy: string;
  modifiedOn?: Date;
  photoBase64: string;

  constructor() {
    this.addressPublic = false;
    this.cellPhonePublic = false;
    this.emailPublic = false;
    this.homePhonePublic = false;
    this.workPhonePublic = false;
  }
}
